/* eslint-disable no-new */
import flickityAsNavFor from "flickity-as-nav-for";
import FlickityClass from "common/utils/ui/flickity-class";
import "./component.scss";

const initSlider = async () => {
  // Find all carousel instances on the page
  const $carousels = document.querySelectorAll(".js-blanks-apparel-benefits-carousel");

  // Initialize each carousel with a unique identifier
  $carousels.forEach(async ($carouselElement, index) => {
    // Skip if already initialized
    if ($carouselElement.classList.contains("flickity-enabled")) {
      return;
    }

    // Add unique class for this instance
    const uniqueClass = `js-blanks-carousel-${index}`;
    $carouselElement.classList.add(uniqueClass);

    const slider = new FlickityClass(
      `.${uniqueClass}`,
      {
        selectedAttraction: 0.01,
        wrapAround: true,
        pageDots: false,
        prevNextButtons: false,
        autoPlay: 5000,
        pauseAutoPlayOnHover: true
      },
      {
        library: flickityAsNavFor
      }
    );

    await slider.initFlickity();

    // Find the prev/next buttons that are siblings of this specific carousel
    const $parentContainer = $carouselElement.parentElement;
    const $prevButton = $parentContainer.querySelector(".js-blanks-apparel-benefits-carousel-prev");
    const $nextButton = $parentContainer.querySelector(".js-blanks-apparel-benefits-carousel-next");

    if ($prevButton) {
      $prevButton.addEventListener("click", () => slider.flickity.previous());
    }

    if ($nextButton) {
      $nextButton.addEventListener("click", () => slider.flickity.next());
    }
  });
};

export default () => {
  initSlider();
};
